import { useState, useMutations } from 'vuex-composition-helpers';
import getStore from '@fr/vue/services/getStore/getStore';
import registerModule from '@fr/vue/services/registerModule';
import FirstPaymentDefinitionRepository, {
    NAMESPACE,
    IFirstPaymentDefinitionMutations,
    IFirstPaymentDefinitionState,
} from '../model/FirstPaymentDefinitionRepository';

export default function () {
    registerModule.register(getStore(), FirstPaymentDefinitionRepository, NAMESPACE);
    const { firstPaymentDefinitions } = useState<IFirstPaymentDefinitionState>(NAMESPACE, ['firstPaymentDefinitions']);
    const { resetFirstPaymentDefinitions, setFirstPaymentDefinitions } = useMutations<IFirstPaymentDefinitionMutations>(NAMESPACE, ['setFirstPaymentDefinitions', 'resetFirstPaymentDefinitions']);

    return {
        resetFirstPaymentDefinitions,
        setFirstPaymentDefinitions,
        firstPaymentDefinitions,
    };
}
